import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProjectList from './Pages/Dashboard';
import Login from './Pages/Login';
import User from './Pages/User';
import ProtectedRoute from './Components/ProtectedRoute';
import CreateProjectDrawer from './Pages/CreateProject';
import DailyLog from './Pages/DailyLogPage';
import TaskForm from './form/TaskForm';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/Login" element={<Login />} />

                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <ProjectList />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/Daily-log"
                    element={
                        <ProtectedRoute>
                            <DailyLog />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/create-project"
                    element={
                        <ProtectedRoute>
                            <CreateProjectDrawer />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/task-details"
                    element={
                        <ProtectedRoute>
                            <TaskForm />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/Users"
                    element={
                        <ProtectedRoute>
                            <User />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
